module.exports = {"url":"https://panelmunkongcvm.one.th/api"}


//////////////////
// WEBPACK FOOTER
// ./src/conf.json
// module id = 62
// module chunks = 0